/**
 * Prins: Vendors > Manifest
 *
 * @copyright 2026 i-fabrik GmbH
 * @author Heiko Pfefferkorn
 */

import ToastNotifications from './toastify';

const vendors = () => {
	ToastNotifications.init();
};

// Export
export default vendors;
